import type { ElementModels } from '@kontent-ai/delivery-sdk/lib/elements/element-models';

import type { ArticleCardData } from '../ArticleCard.types';

type BlogToCardConverter = (content: any) => ArticleCardData;

export const blogToCardConverter: BlogToCardConverter = content => {
  const thumbnailImageElement = content.elements.thumbnail_image
    .value[0] as ElementModels.AssetModel;
  const authorElement = content.elements.byline.linkedItems[0] as any;
  const authorImageElement = authorElement?.elements.image.value[0] as ElementModels.AssetModel;
  return {
    author: authorElement && {
      fullName: authorElement.elements.full_name.value,
      image: authorImageElement && {
        url: authorImageElement.url,
        description: authorImageElement.description,
      },
    },
    createdAt: content.elements.created_at.value || '',
    heading: content.elements.heading.value,
    slug: content.elements.slug.value,
    subheading: content.elements.subheading.value || undefined,
    thumbnailImage: {
      url: thumbnailImageElement?.url,
      description: thumbnailImageElement?.description,
    },
  };
};
